export const CT_PLAYER_TYPE = {
	RETAIL: 'retail',
	ONLINE: 'online'
}

export const CT_BANKER_TYPE = {
	ONE_AGAINST_ALL: 'banker_one_against_all',
	AGAINST_ALL: 'banker_against_all'
}

export const CT_BANKER_CONFIG = {
	// Banker one against all: only 1 ball can be selected
	ONE_AGAINST_ALL: {
		MIN_BALLS: 1,
		MAX_BALLS: 1,
		// Total number of balls the 1 banker plays against (for 5/90 game, 90 - 1 = 89)
		AGAINST_BALLS: 89,
		// Price per combination
		PRICE_PER_COMBINATION: 50
	},
	// Banker against all: other balls range
	AGAINST_ALL: {
		OTHER_MIN: 1,
		OTHER_MAX: 20,
		// Price per combination
		PRICE_PER_COMBINATION: 50
	}
}